import { GenIcon } from '../helpers/IconBase.es.js';

const TvNewOutlined = (props) => {
  return GenIcon({
    tag: "svg",
    attr: {
      id: "Capa_1",
      enableBackground: "new 0 0 512 512",
      viewBox: "0 0 512 512"
    },
    child: [
      {
        tag: "g",
        attr: {},
        child: [
          {
            tag: "path",
            attr: {
              d: "m255.85 48.5c5.521 0 10-4.49 10-10 0-5.521-4.479-10-10-10-5.51 0-9.99 4.479-9.99 10-.001 5.51 4.48 10 9.99 10z"
            }
          },
          {
            tag: "path",
            attr: {
              d: "m508.069 59.04c-2.52-5.96-6.13-11.3-10.72-15.891-4.59-4.59-9.93-8.199-15.89-10.72-6.16-2.61-12.71-3.93-19.46-3.93h-161.14c-5.52 0-10 4.479-10 10 0 5.51 4.48 10 10 10h161.141c16.51.03 29.97 13.49 30 30v230h-472v-230c.03-16.51 13.49-29.97 30-30h160.859c5.511 0 9.99-4.49 9.99-10 0-5.521-4.479-10-9.99-10h-160.859c-6.75 0-13.3 1.319-19.46 3.93-5.96 2.521-11.3 6.13-15.891 10.72-4.589 4.591-8.199 9.931-10.719 15.891-2.611 6.16-3.93 12.71-3.93 19.46v270c0 27.57 22.43 50 50 50h166v25h-35c-27.57 0-50 22.43-50 50 0 5.522 4.478 10 10 10h230c5.522 0 10-4.478 10-10 0-27.57-22.43-50-50-50h-35v-25h166c27.57 0 50-22.43 50-50v-270c0-6.75-1.32-13.3-3.931-19.46zm-222.069 384.46h45c13.037 0 24.159 8.359 28.286 20h-206.572c4.127-11.641 15.249-20 28.286-20h45c5.522 0 10-4.478 10-10v-35h40v35c0 5.522 4.478 10 10 10zm206-95c0 16.542-13.458 30-30 30h-412c-16.542 0-30-13.458-30-30v-20h472z"
            }
          },
          {
            tag: "path",
            attr: {
              d: "m132 138.5v46.023l-31.485-51.118c-2.346-3.808-6.932-5.594-11.24-4.377-4.304 1.219-7.274 5.147-7.274 9.621v79.851c0 5.522 4.478 10 10 10s10-4.478 10-10v-44.547l29.642 48.124c2.711 4.393 7.677 6.451 12.353 5.124 4.863-1.38 8.006-5.854 8.006-11.397v-77.304c0-5.522-4.478-10-10-10s-10.002 4.478-10.002 10z"
            }
          },
          {
            tag: "path",
            attr: {
              d: "m182 128.5c-5.522 0-10 4.478-10 10v80c0 5.522 4.478 10 10 10h34c5.522 0 10-4.478 10-10s-4.478-10-10-10h-24v-20h24c5.522 0 10-4.478 10-10s-4.478-10-10-10h-24v-20h24c5.522 0 10-4.478 10-10s-4.478-10-10-10z"
            }
          },
          {
            tag: "path",
            attr: {
              d: "m401.465 208.5c-4.993 0-9.951-2.834-13.264-7.581-3.161-4.53-9.395-5.638-13.924-2.479-4.529 3.161-5.639 9.395-2.479 13.924 7.051 10.104 18.141 16.136 29.666 16.136 13.228 0 24.644-9.584 27.761-23.307 3.288-14.471-3.813-28.241-18.091-35.081-1.851-.887-13.94-6.589-16.003-8.235-1.182-.942-2.126-3.558-1.646-6.73.17-1.122.963-4.875 4.035-6.077 6.301-2.462 12.873 4.21 13.124 4.468 3.736 4.016 10.021 4.271 14.074.561 4.072-3.73 4.35-10.057.619-14.129-5.826-6.359-19.773-15.521-35.104-9.524-8.81 3.447-14.986 11.562-16.522 21.707-1.519 10.026 1.909 19.743 8.944 25.357 3.89 3.105 18.026 9.773 19.837 10.641 7.922 3.795 7.93 9.531 7.229 12.613-.871 3.843-3.989 7.736-8.256 7.736z"
            }
          },
          {
            tag: "path",
            attr: {
              d: "m253.988 128.704c-5.41 1.111-8.895 6.398-7.784 11.808 0 0 16.425 79.774 16.599 80.246 1.711 4.64 6.184 7.742 11.149 7.742h.083c4.997-.035 9.467-3.208 11.122-7.896.031-.09 15.844-49.281 15.844-49.281s15.774 49.298 15.824 49.435c1.711 4.64 6.184 7.742 11.149 7.742h.083c4.997-.035 9.467-3.208 11.122-7.896.15-.427.977-4.275.977-4.275l15.636-75.66c1.118-5.408-2.36-10.698-7.77-11.816-5.397-1.118-10.698 2.36-11.816 7.77l-9.933 48.062s-15.97-49.809-16.087-49.965c-1.1-2.571-3.257-4.672-6.128-5.595-5.256-1.691-10.89 1.203-12.58 6.461l-15.783 49.104-9.9-48.203c-1.111-5.41-6.4-8.891-11.807-7.783z"
            }
          }
        ]
      }
    ]
  })(props);
};

export { TvNewOutlined };
